import { Box, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { Label, InputField, FormGroup, CreateButton } from '../SharedComponents';
import CustomDatePicker from '../CustomDatePicker'; // Import CustomDatePicker
import moment, { Moment } from 'moment';
import { EditableInventoryInterface, InventoryInterface, SidePanelInterface } from '../../types';
import notify from '../../services/notify';

const fieldRowStyle = {
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	'@media (max-width: 768px)': {
		flexDirection: 'column',
	},
};

const RecordStockEntryForm = ({
	variant,
	handleHidePanel,
	handleSave,
	defaultValues,
}: {
	variant?: InventoryInterface | null;
	handleSave: (a: EditableInventoryInterface) => any;
	defaultValues?: { batch_no: string; quantity: number; expiration_date: Moment | null; variant_tracker_id?: number };
} & Omit<SidePanelInterface, 'isVisible' | 'children'>) => {
	const [batchNumber, setBatchNumber] = useState<string>('');
	const [quantity, setQuantity] = useState<number>(0);
	const [expirationDate, setExpirationDate] = useState<Moment | null>(null);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	useEffect(() => {
		if (defaultValues) {
			setBatchNumber(defaultValues.batch_no);
			setQuantity(defaultValues.quantity);
			setExpirationDate(defaultValues.expiration_date ? moment(defaultValues.expiration_date) : null);
		}
	}, [variant, defaultValues]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { name, value } = e.target;
		if (name === 'batchNumber') {
			setBatchNumber(value);
		} else if (name === 'quantity') {
			setQuantity(Math.abs(Number(value)));
		}
	};

	const handleDateChange = (date: Moment | null) => {
		setExpirationDate(date);
	};

	const isFieldsValid = () => {
		// if (batchNumber.length === 0) {
		//     notify("error", "Batch number is required");
		//     return false;
		// }
		if (quantity === 0) {
			notify('error', 'Quantity is required');
			return false;
		}
		return true;
	};

	const handleOnSaveClick = () => {
		if (!isFieldsValid()) return;

		setIsLoading(true);

		const batchJson: EditableInventoryInterface = {
			quantity: quantity,
			variant_id: variant?.variant_id,
		};

		if (batchNumber.length > 0) {
			batchJson.batch_no = batchNumber;
		}

		if (expirationDate) {
			batchJson.expiration_date = expirationDate.format('YYYY-MM-DD');
		}

		console.log('batchJson', batchJson);

		handleSave(batchJson)
			.then((responseData: any) => {
				handleHidePanel(responseData);
			})
			.catch((error: any) => {
				console.log('Error recording entry', error);
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	return (
		<>
			<div>{defaultValues ? 'Edit' : 'Record'} Stock Entry</div>
			<Box sx={fieldRowStyle}>
				<FormGroup style={{ marginRight: '20px' }}>
					<Label>Batch No.(optional):</Label>
					<InputField type="text" name="batchNumber" value={batchNumber} onChange={handleChange} />
				</FormGroup>
				<FormGroup>
					<Label>Quantity</Label>
					<InputField type="number" name="quantity" value={quantity} onChange={handleChange} />
				</FormGroup>
			</Box>
			<FormGroup>
				<CustomDatePicker label="Expiration Date" value={expirationDate} onChange={handleDateChange} />
			</FormGroup>
			<Box sx={{ display: 'flex', flexDirection: 'row', marginTop: '10px' }}>
				<CreateButton onClick={handleOnSaveClick}>
					<CircularProgress
						style={{ visibility: isLoading ? 'visible' : 'hidden', position: 'absolute' }}
						size={15}
						color="inherit"
					/>
					<span style={{ visibility: isLoading ? 'hidden' : 'visible' }}>Save</span>
				</CreateButton>
				{defaultValues && (
					<CreateButton onClick={() => handleHidePanel()} style={{ marginLeft: '10px' }} outline>
						<span>Cancel</span>
					</CreateButton>
				)}
			</Box>
		</>
	);
};

export default RecordStockEntryForm;
